module.exports = __webpack_public_path__ + "static/media/modelo-cilindro.469cdc53.png";